'use client';

import React, { useContext } from 'react';
import SignInMobile from '$modules/onboarding/screens/sign-in/signIn.mobile';
import SignInWeb from '$modules/onboarding/screens/sign-in/signIn.web';
import { GlobalContext } from '$context/global-context';
const SignInPage: React.FC = () => {
  const {
    state
  } = useContext(GlobalContext);
  const isMobile = state.screen.isMobile;
  return <>{isMobile ? <SignInMobile /> : <SignInWeb />}</>;
};
export default SignInPage;